import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';

export interface IUserOrgLookupResponse {
    user?: {
        email: string;
        isDisabled: boolean;
    };
    org?: {
        name: string;
        hasDealAccess: boolean;
    };
}

const signUpUserOrgLookup = async (email: string): Promise<IUserOrgLookupResponse> => {
    const response = await axiosInstance.get(API_ENDPOINTS.SIGNUP.USER_ORG_LOOKUP, {
        params: { email },
    });
    return response.data;
};

export const useSignUpUserOrgLookup = (email: string, options?: any) => useQuery<IUserOrgLookupResponse, Error>({
    queryKey: [QUERY_KEYS.SIGNUP.USER_ORG_LOOKUP, email],
    queryFn: () => signUpUserOrgLookup(email),
    ...options,
});

export default useSignUpUserOrgLookup;
